export default __webpack_public_path__ + "static/media/logo-black.5c39ad4c.png";